import React from "react";
import TeamMembers from "./TeamMembers";

const obj1 = {

Rohit: {
  Image: "/assets/allmembers24/ROHIT1.jpg",
  Role: "General Secretary",
  Name: "Rohit Ambre",
  Email: "rohitambre67@gmail.com",
  Linkedin: "https://www.linkedin.com/in/rohit-ambre-b0b518260?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app"  
},

Pranit: {
  Image: "/assets/allmembers24/pranit1.jpg",  
  Role: "President",
  Name: "Pranit Kamble",
  Email: "pranitkamble312@gmail.com",
  Linkedin: ""
  },

Aditi: {
  Image: "/assets/allmembers24/aditi1.jpg",  
  Role: "Co-General Secretary",
  Name: "Aditi Kadam",
  Email: "aditikadam3636@gmail.com",
  Linkedin: "https://www.linkedin.com/in/aditi-kadam-b9ba5130b?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app"
},

Aniket: {
  Image: "/assets/allmembers24/aniket1.jpg",
  Role: "Convenor",
  Name: "Aniket Chavan",
  Email: "ac18052004@gmail.com",
  Linkedin: "https://www.linkedin.com/in/aniket-chavan-6ab452258?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app"
},

Arya: {
  Image: "/assets/allmembers24/Arya1.jpg",
  Role: "Co-Convenor",
  Name: "Arya Dhuri",
  Email: " aryadhuri2004@gmail.com ",
  Linkedin: "https://www.linkedin.com/in/arya-dhuri-90b107216?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app"
},

Aman: {
  Image: "/assets/allmembers24/aman1.jpg",
  Role: "Treasurer",
  Name: "Aman Jain ",
  Email: "aman.p.jain19@gmail.com ",
  Linkedin: "https://www.linkedin.com/in/aman-jain-4809ba287?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=ios_app"
},

Rishee: {
  Image: "/assets/allmembers24/Rishee1.jpg",
  Role: "Treasurer",
  Name: "Rishee Bauskar ",
  Email: "rishee.bauskar@gmail.com",
  Linkedin: "https://www.linkedin.com/in/rishee-bauskar-a6a099288?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",  
},

Shrushti: {
  Image: "/assets/allmembers24/shrushti11.jpg",
  Role: "Lady Representative",
  Name: "Shrushti Ambre",
  Email: "shrushtiambre788@gmail.com",
  Linkedin: " "
},

Sujay: {
  Image: "/assets/allmembers24/Suja1y.jpg",
  Role: "Documentation Head",
  Name: "Sujay Kangane",
  Email: "sujaykangane0@gmail.com ",  
  Linkedin: " https://www.linkedin.com/in/sujay-kangane-991568289?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app"
},

Uday: {
  Image: "/assets/allmembers24/uday.jpg",
  Role: "Documentation Head",
  Name: "Uday Patil",
  Email: "udaypatil088@gmail.com",
  Linkedin: "https://www.linkedin.com/in/uday-patil-8472b120b?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app"
},

Smruti: {
  Image: "/assets/allmembers24/smruti11.jpg",
  Role: "Cultural Head",
  Name: "Smruti Desai",
  Email: "smrutid1011@gmail.com",
  Linkedin: "https://www.linkedin.com/in/smruti-desai-45a19821b?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app"
  },

Esha: {
  Image: "/assets/allmembers24/esha1.jpg",
  Role: "Co-Cultural Head",
  Name: "Esha Ambekar",
  Email: "eshaambekar7@gmail.com ",
  Linkedin: "https://www.linkedin.com/in/esha-ambekar-4b4313246?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app"
  },

Shivam: {
  Image: "/assets/allmembers24/Shivam1.jpg",
  Role: "Co-Cultural Head",
  Name: "Shivam Gupta",
  Email: "shivamgupta04108@gmail.com",
  Linkedin: "https://www.linkedin.com/in/shivam-gupta-a5347531a"
  },

Suraj: {
  Image: "/assets/allmembers24/suraj1.jpg",
  Role: "Design Head",
  Name: "Suraj Gaikar",
  Email: "surajgaikar4694@gmail.com",
  Linkedin: "https://www.linkedin.com/in/suraj-gaikar-695095237?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app"
  },

Krushnal: {
  Image: "/assets/allmembers24/krushnal1.jpg",
  Role: "Design Head",
  Name: "Krushnal Patil",
  Email: "patilkrushnalkishor@gmail.com", 
  Linkedin: "https://www.linkedin.com/in/krushnal-patil?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=ios_app"  
},

Pranil: {
  Image: "/assets/allmembers24/pranil.jpg",
  Role: "Sports Head",
  Name: "Pranil Patil",
  Email: "patilpranil1018@gmail.com",  
 Linkedin: " https://www.linkedin.com/in/pranil-patil-pp501vk?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=ios_app"  
},

Sumit: {
  Image: "/assets/allmembers24/sumit1.jpg",
  Role: "Sports Head",
  Name: "Sumit Lodh",
  Email: "lodh.sumit2805@gmail.com ",  
  Linkedin: ""  
},

Durgesh: {
  Image: "/assets/allmembers24/durgesh1.jpg",
  Role: "Co-Sports Head",
  Name: "Durgesh Thorat",
  Email: "thoratdurgeshprakash@gmail.com",  
 Linkedin: " https://www.linkedin.com/in/durgesh-thorat-6ab639248?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app"  
},

Viraj: {
  Image: "/assets/allmembers24/viraj1.jpg",
  Role: "Social-Media Head",
  Name: "Viraj Salvi",
  Email: "virajsalvigc@gmail.com",
  Linkedin: "https://www.linkedin.com/in/viraj-salvi-045538149/"
},

Vedant: {
  Image: "/assets/allmembers24/Vedant1.jpg",
  Role: "Publicity Head",
  Name: "Vedant Mandavkar",
  Email: "vedantmandavkar3@gmail.com ",
  Linkedin: "https://www.linkedin.com/in/vedant-mandavkar-4a6aa924b?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=ios_app"
}

};

const obj2 = {
Sanika: {
  Image: "/assets/allmembers24/Sanika1.jpg",
  Role: "TECH-GITS Head",
  Name: "Sanika Dixit",
  Email: "it.a.33.sanika.dixit@gmail.com",
  Github: "https://github.com/sanika-d",
  Linkedin: "www.linkedin.com/in/sanika-dixit-96a842251"
},

Dhiraj: {
  Image: "/assets/allmembers24/Dhiraj1.jpg",
  Role: "TECH-GITS Member",
  Name: "Dhiraj Jambhale",
  Email: "dhirajjambhale025@gmail.com ",
  Github: "https://github.com/Dhiraj025 ",
  Linkedin: "https://www.linkedin.com/in/dhiraj-jambhale2503?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app"
},

Omkar: {
  Image: "/assets/allmembers24/omkar1.jpg",
  Role: "TECH-GITS Member",
  Name: "Omkar Bhapkar",
  Email: " ",
  Github: "https://github.com/omiii04",
  Linkedin: "https://www.linkedin.com/in/omkar-bhapkar-687420259?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app"
},

Shrish: {
  Image: "/assets/allmembers24/shrish.jpg",
  Role: "TECH-GITS Member",
  Name: "Shrish Kadam",
  Email: " shrishkadam18@gmail.com  ",
  Github: "https://github.com/shrish-hub",
  Linkedin: "https://www.linkedin.com/in/shrish-kadam"
},

Vedashri: {
  Image: "/assets/allmembers24/vedashri.jpg",
  Role: "TECH-GITS Member",
  Name: "Vedashri Chorge",
  Email: "vedashrichorge0707@gmail.com ",
  Github: "https://github.com/Vedashri0",
  Linkedin: "https://www.linkedin.com/in/vedashrichorge"
},

Pranav: {
  Image: "/assets/allmembers24/pranav1.jpg",
  Role: "TECH-GITS Member",
  Name: "Pranav Bangar",
  Email: "pranavbangar2@gmail.com ",
  Github: "https://github.com/pranaxvv",
  Linkedin: "https://www.linkedin.com/in/pranav-bangar-a43a41320?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app"
},

Pratik: {
  Image: "/assets/allmembers24/pratik11.jpg",
  Role: "TECH-GITS Member",
  Name: "Pratik Sonawane",
  Email: " sonawanepratik962003@gmail.com",
  Github: "https://github.com/iampratik9",
  Linkedin: "https://www.linkedin.com/in/pratik-sonawane-547177248"
},

Rushikesh: {
  Image: "/assets/allmembers24/Rushikesh1.jpg",
  Role: "TECH-GITS Member",
  Name: "Rushikesh Deshmukh",
  Email: "rushikeshd1907@gmail.com ",
  Github: "https://github.com/Rushi1907",
  Linkedin: "https://www.linkedin.com/in/rushikesh-deshmukh-0524bb238"
},

Manish: {
  Image: "/assets/allmembers24/manish1.jpg",
  Role: "TECH-GITS Member",
  Name: "Manish Sonawane",
  Email: " ",
  Github: "https://github.com/manish14012004",
  Linkedin: "https://www.linkedin.com/in/sonawane-manish-atul-51731524a?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app"
}

};


const Team = () => {
  return (
    <div
      className="flex flex-col justify-center items-center mt-20"
      data-aos="zoom-in"
    >
      <h1 className="font-larabieBold text-7xl text-center text-[#00ffff] md:my-5">
        OUR TEAM
      </h1>
      <div className="flex flex-wrap justify-center items-center ">
        {Object.keys(obj1).map((key) => {
          return (
            <div className="mx-5 my-5">
              <TeamMembers
                name={obj1[key].Name}
                role={obj1[key].Role}
                insta={obj1[key].Instagram}
                linkedin={obj1[key].Linkedin}
                github={obj1[key].Github}
                email={obj1[key].Email}
                image={obj1[key].Image}
              />
            </div>
          );
        })}
      </div>
      <h1 className="font-larabie text-7xl text-center text-[#00ffff] md:my-5">
        TECH-GITS
      </h1>
      <div className="flex flex-wrap justify-center items-center ">
        {Object.keys(obj2).map((key) => {
          return (
            <div className="mx-5 my-5 ">
              <TeamMembers
                name={obj2[key].Name}
                role={obj2[key].Role}
                insta={obj2[key].Instagram}
                linkedin={obj2[key].Linkedin}
                github={obj2[key].Github}
                email={obj2[key].Email}
                image={obj2[key].Image}
              />
            </div>
          );
        })}
      </div>
      {/* <h1 className="font-larabieBold text-7xl text-center text-[#00ffff] md:my-5">
        Coming Soon ...
      </h1>
      <br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/> */}
    </div>
  );
};

export { obj1, obj2 };
export default Team;